import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devSearchSchemaFor } from "@/modules/dev/registry/previews";

export const Route = createFileRoute("/dev/survey-components")({
  validateSearch: devSearchSchemaFor("survey-components"),
  component: lazyRouteComponent(
    () => import("@/modules/session-survey/dev/SurveyComponentsPreview"),
    "SurveyComponentsPreview",
  ),
});
